export const GROUPS_ROUTES = {
	groups: "/app/groups",
} as const;
